import React from 'react'
import Image from '../../../images/buyerpolicies/Scam.png'

const Scam = () => {
  return (
    <div className='sp_details_wrapper'>
      <div className='sp_details_container'>
        <div className='sp_details_image'>
            <img src={Image} alt='policy'/>
        </div>
        <div className='sp_details_details'>
            <h2>Scam</h2>
            <p>In case of any scam, it will be completely and wholly sent to the government and KAAY observes a legal right to end the order if there is any mistrust or misbehavior under the contract.</p>
        </div>
      </div>
    </div>
  )
}

export default Scam
